export default __webpack_public_path__ + "static/media/IconCogwheelActive.1bdd46a4.svg";